import React from 'react';
import {
  StyleSheet,
  ScrollView,
  SafeAreaView,
  View,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';

import ExpenseWidget from '../../ExpenseWidget/ExpenseWidget';
import useChargeBottomSheetActions from '../../../utils/useChargeBottomSheetActions';
import { Color, CommonStyles } from '../../../styles';
import BaseText from '../../BaseText';
import { scale, scaleVertically } from '../../../utils/scale.utils';
import { useSelector } from 'react-redux';
import { selectCurrentExpenseReportCardModalItem } from '../../../store/selectors/expense.selector';
import useExpenseHeaderSetup from '../../../utils/useExpenseHeaderSetup';
import { Source } from '../../../constants/Enums';

const TripExpenseAddModal = ({ route }) => {
  const navigation = useNavigation();
  const currentExpenseReportCardModalItem = useSelector(selectCurrentExpenseReportCardModalItem);
  const { selectedType, fromExistingReport = false } = route?.params || {};
  const [expenseChargesRef, chargeSheetActions, ChargeBottomSheet] = useChargeBottomSheetActions(
    fromExistingReport
  );

  useExpenseHeaderSetup({
    navigation,
    fromExistingReport,
    fromDrawer: !fromExistingReport,
    reportNumber: currentExpenseReportCardModalItem?.ReportNumber,
  });

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView
        style={CommonStyles.flex1}
        behavior={Platform.OS === Source.IOS ? 'padding' : ''}
        keyboardVerticalOffset={Platform.OS === Source.IOS ? 100 : 0}
      >
        <ScrollView nestedScrollEnabled={true}>
          <View style={styles.titleContainer}>
            <BaseText style={styles.title}>Create New Entry</BaseText>
          </View>
          <ExpenseWidget
            option={selectedType}
            chargeSheetActions={chargeSheetActions}
            expenseChargesRef={expenseChargesRef}
            fromExistingReport={fromExistingReport}
          />
        </ScrollView>
        {/* Using ChargeBottomSheet as an element to preserve transition effects */}
        <View>{ChargeBottomSheet}</View>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.background,
  },
  titleContainer: {
    alignItems: 'center',
  },
  title: {
    color: Color.primary,
    fontSize: scale(17),
    marginVertical: scaleVertically(12),
  },
});

export default TripExpenseAddModal;
